import React, {useContext} from "react";
import PackingMaterialslist from './ManageOrShowPackingMaterials'
import {RoundNumber} from "../CommonComponents/CommonFunctions";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";

export default () => {
    let RecordsManagement = useContext(RecordsManagementContext)
    let ViewManagement = useContext(ViewMangementContext)
    let ClientHasPermissionToEdit = RecordsManagement.IsJobOpen
    let PackingMaterials = RecordsManagement.CP_PageDetails.PackingMaterials
    let Currency = RecordsManagement.CP_PageDetails.Currency
    let isUpdateMaterials = RecordsManagement.CP_PageDetails.editFields.material

    // if estimate is not booked then we can add or update packing material in this modal otherwise this modal just show the packing materials added earlier.
    const EditShowPackingMaterials = () => {
        ViewManagement.setModalContent({
            Title: ClientHasPermissionToEdit ? 'Manage Packing Materials' : 'Packing Materials List',
            Class: 'pack-mat',
            Body: <PackingMaterialslist PackingMaterials={PackingMaterials}
                                        Functionality={ClientHasPermissionToEdit ? "Manage" : "Show"}/>
        })
    }
 //this component  is shown on the above modal which contains the packing materials details (name,qty,price) that was added earlier.
    const PackingMaterialDetails = (props) => {
        let PackingMaterial = props.PackingMaterial
        return (
            <tr className="first-tr">
                <td id="td-cls" data-label="Product">
                    {PackingMaterial.Name}
                </td>
                <td id="td-cls" data-label="QTY">
                    <span>{PackingMaterial.Qty}</span>
                </td>
                <td id="td-cls" data-label="Per Unit">
                    <span> {Currency} {PackingMaterial.Price}</span>
                </td>
                <td id="td-cls" data-label="Total">
                    {Currency} {RoundNumber(PackingMaterial.TotalPrice)}
                </td>
            </tr>
        )
    }

    const PackingMaterialsEditShowBtn = () => {
        // If estimate is not booked then button "Manage Packing Materials" will shown otherwise "Show Packing Materials"
        return (
            <li>
                <button className="update-btn" onClick={() => EditShowPackingMaterials()}
                        data-toggle="modal" data-target="#Modal">
                    {ClientHasPermissionToEdit ? 'Manage Packing Materials' : 'Show Packing Materials'}
                </button>
            </li>
        )
    }
 //shows the packing materials
    const PackingMaterialsTable = () => {
        return (
            <>
                {PackingMaterials.List.length > 0 ?
                    <>
                        <li style={{maxHeight: '238px', overflow: "auto" }}>
                            <table className="table mb-0 estimated-cost-tbl description packing-material">
                                <thead>
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Per Unit</th>
                                    <th scope="col">Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                {PackingMaterials.List.map((packing_material, key) => {
                                    return (<PackingMaterialDetails key={key} PackingMaterial={packing_material}/>)
                                })}
                                </tbody>
                            </table>
                        </li>
                        <li><h6 className="head-h6">Estimated Materials Total = {}
                              { Currency}{RoundNumber(PackingMaterials.TotalPrice)}</h6></li>
                    </>
                    : ''}
                {isUpdateMaterials || !ClientHasPermissionToEdit ? <PackingMaterialsEditShowBtn/> : <></> }
            </>
        )
    }

    return (
        <div className="contact-information mb-4">
            <ul className="contact-info-list pl-0 mb-0">
                <li><h6>Packing Materials</h6></li>
                <PackingMaterialsTable/>
            </ul>
        </div>
    )
};